// HM-305: Toast tramite sonner pre-stylato palette warm.
// Esposto Toaster (provider) + helper toast() per tutti i 9 moduli.

import { Toaster as SonnerToaster, toast } from 'sonner';

export function Toaster() {
  return (
    <SonnerToaster
      position="top-right"
      richColors={false}
      closeButton
      duration={3500}
      toastOptions={{
        unstyled: false,
        classNames: {
          toast:
            'bg-bg-card text-text-primary border border-border-base shadow-hm-md rounded-lg p-4',
          title: 'text-sm font-semibold',
          description: 'text-xs text-text-secondary',
          actionButton: 'bg-accent-primary text-text-on-accent hover:bg-accent-primary-hover',
          cancelButton: 'text-text-secondary',
          closeButton: 'text-text-muted hover:text-text-primary border-border-base',
          success: 'border-l-4 border-l-state-lib',
          error: 'border-l-4 border-l-state-guas',
          warning: 'border-l-4 border-l-state-puliz',
          info: 'border-l-4 border-l-state-ris',
        },
      }}
    />
  );
}

export { toast };
